import Form from "../form/form"
import $ from 'jquery';

window.addEventListener('DOMContentLoaded', () => {
  const rateQuoteModal = document.querySelector('#modal-rate-quote')

  if (!rateQuoteModal) {
    return;
  }

  const formElem = rateQuoteModal.querySelector('form')

  if (!formElem) {
    return;
  }


  const form = new Form(formElem)

  form.successHandler = function(data) {
    let userGreeting = rateQuoteModal.querySelector('.user-greeting')
    if (!userGreeting) {
      return;
    }

    let firstNameInput = formElem.querySelector('input[name=firstName]')
    if (firstNameInput) {
      let name = firstNameInput.value.trim()
      userGreeting.textContent = name.length && `thanks ${name.toLowerCase()}!` || 'thank you!'
    }

    rateQuoteModal.classList.add('success')
  }
})

